import { empty, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ICartItem } from "../interfaces/ICartItem";
import { IItemIndicator } from "../interfaces/IItemIndicator";
import { IUserBudget } from "../interfaces/IUserBudget";
import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import { CookieService } from "./cookieService";
import EnvironmentService from "./environmentService";
import HttpClient from "./httpClient";
import { ICartServicePayload } from "wbm-cart-service/interfaces/cartServicePayload";
import { ICartItems } from "wbm-cart-service/interfaces/cartItems";
import { ICartRemoveResponse } from "@wbmason/cart-service/interfaces/cartRemoveResponse";

export const CartChangeCookie = "__wb_mh_crtchng__";

export const CartService = {
  getCart(): Observable<ICartServicePayload> {
    return HttpClient.get<ICartItems>({
      baseUri: ApiEndpointResolver.getCartItemsUrl(),
    }).pipe(
      map((cartResponse) => {
        cartResponse.items.forEach((ci) => {
          if (!ci.itemLineRecId) {
            ci.itemLineRecId = ci.id;
          }
        });
        return { cart: cartResponse, connectionId: "" };
      })
    );
  },
  getUserBudget(): Observable<IUserBudget> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getUserBudgetUrl(),
    });
  },
  getItemIndicators(
    itemIndicatorIds: {
      id: string;
      unitId: string;
      externalContractCode: string;
      priceCode: string;
    }[]
  ): Observable<IItemIndicator[]> {
    return HttpClient.post({
      baseUri: ApiEndpointResolver.getItemIndicatorsUrl(),
      body: itemIndicatorIds,
    });
  },
  /** obsolete due to using signalR */
  removeItem(cartItem: ICartItem): Observable<ICartRemoveResponse> {
    let observable: Observable<ICartRemoveResponse>;
    if (IsEcom() || !EnvironmentService.get().removeCartItemUrl) {
      observable = HttpClient.post<ICartRemoveResponse>({
        baseUri: ApiEndpointResolver.removeCartItemUrl(cartItem),
        body: {
          productId: cartItem.kitItemId
            ? cartItem.kitItemId
            : cartItem.itemIdentifier.id,
          isKitItem: cartItem.kitItemId ? true : false,
        },
      });
    } else {
      observable = HttpClient.delete<ICartRemoveResponse>({
        baseUri: ApiEndpointResolver.removeCartItemUrl(cartItem),
        withCredentials: true,
      });
    }

    return observable.pipe(
      map((r: ICartRemoveResponse) => {
        this.setCartChangeCookie();

        r.cartItems.forEach((ci) => {
          if (!ci.itemLineRecId) {
            ci.itemLineRecId = ci.id;
          }
        });

        return r;
      })
    );
  },
  getBudgetType(): Observable<number> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getBudgetTypeUrl(),
    });
  },
  getCartChangeCookie(): string | undefined {
    const cookie = CookieService.get(CartChangeCookie);
    if (cookie) {
      CookieService.remove(CartChangeCookie);
    }
    return cookie;
  },
  setCartChangeCookie() {
    CookieService.set(CartChangeCookie, Date.now().toString());
  },
  addCartItems() {
    return empty();
  },
  removeCartItem() {
    return empty();
  }
};
